import { __rest, __assign, __spreadArrays } from 'tslib';
import React__default, { createElement, useContext, useEffect, useRef, useState } from 'react';
import { Snackbar, SnackbarContent, Typography, IconButton as IconButton$1, makeStyles as makeStyles$1, Avatar as Avatar$1, Box as Box$1, Button as Button$1, MenuItem, Popper, Grow, Paper, ClickAwayListener, MenuList, withStyles as withStyles$1, Checkbox as Checkbox$1, fade, Chip as Chip$1, SvgIcon, Link as Link$1, Modal as Modal$1, createStyles, Radio as Radio$1, TextField, FormControl, Select as Select$1, Table as Table$1, TableRow as TableRow$1, TableCell as TableCell$1, TableSortLabel as TableSortLabel$1, CssBaseline } from '@material-ui/core';
export { Chip as BaseChip, Select as BaseSelect, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, CircularProgress, ClickAwayListener, Collapse, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Drawer, ExpansionPanel, ExpansionPanelActions, ExpansionPanelDetails, ExpansionPanelSummary, Fade, FilledInput, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, Grow, Hidden, Input, InputAdornment, InputLabel, LinearProgress, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, MobileStepper, NativeSelect, OutlinedInput, Paper, Popover, RadioGroup, Slide, Slider, Tab, TableBody, TableContainer, TableHead, Tabs, TextField, Tooltip, Typography, Zoom, createStyles, makeStyles, styled, useMediaQuery, useRadioGroup, withStyles } from '@material-ui/core';
import { makeStyles, createMuiTheme, fade as fade$1, MuiThemeProvider } from '@material-ui/core/styles';
export { useTheme } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import NotificationsActiveTwoTone from '@material-ui/icons/NotificationsActiveTwoTone';
import { Alert as Alert$1, Pagination as Pagination$1 } from '@material-ui/lab';
export { Autocomplete, Skeleton, ToggleButton, ToggleButtonGroup, createFilterOptions } from '@material-ui/lab';
import { withStyles, makeStyles as makeStyles$2 } from '@material-ui/styles';
import { useId } from '@reach/auto-id';
import clsx from 'clsx';
export { DatePicker, DateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import MaterialIconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { fade as fade$2 } from '@material-ui/core/styles/colorManipulator';
import * as colorManipulator from '@material-ui/core/styles/colorManipulator';
export { colorManipulator as ColorManipulator };
var Liquidity = {
  colors: {
    main: {
      primary: '#06A946',
      secondary: '#103F76',
      midBlue: '#11305D',
      darkBlue: '#0A2446',
      brightBlue: '#04A1C8'
    },
    feedback: {
      success: '#05B2DC',
      warning: '#F5A623',
      error: '#BB3100'
    },
    greys: {
      background: '#F6F6F6',
      light: '#D8D8D8',
      mid: '#757575',
      base: '#333333',
      form: '#979797'
    },
    text: {
      standard: 'rgba(0, 0, 0, 0.8)',
      standardLight: 'rgba(0, 0, 0, 0.54)',
      accent: 'rgba(16, 63, 118, 1)',
      error: 'rgba(187, 49, 0, 1)',
      inverse: 'rgba(255,255,255,1)'
    }
  },
  measurements: {
    shape: {
      borderRadius: 5
    },
    spacing: 8
  }
};
var _a;
var ALERT_VARIANTS = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info'
};
var ALERT_VARIANTS_COLORS = (_a = {}, _a[ALERT_VARIANTS.success] = Liquidity.colors.feedback.success, _a[ALERT_VARIANTS.warning] = Liquidity.colors.feedback.warning, _a[ALERT_VARIANTS.error] = Liquidity.colors.feedback.error, _a[ALERT_VARIANTS.info] = Liquidity.colors.greys.base, _a);
var useStyles = /*#__PURE__*/
makeStyles(function (theme) {
  var _a;
  return _a = {}, _a[ALERT_VARIANTS.success] = {
    backgroundColor: Liquidity.colors.feedback.success
  }, _a[ALERT_VARIANTS.warning] = {
    backgroundColor: Liquidity.colors.feedback.warning
  }, _a[ALERT_VARIANTS.error] = {
    backgroundColor: Liquidity.colors.feedback.error
  }, _a[ALERT_VARIANTS.info] = {
    backgroundColor: Liquidity.colors.greys.base
  }, _a.icon = {
    fontSize: 24,
    marginRight: theme.spacing(3)
  }, _a.message = {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit'
  }, _a;
});
var Alert = function Alert(_a) {
  var variant = _a.variant,
    children = _a.children,
    onClose = _a.onClose,
    testId = _a.testId,
    closeButtonTestId = _a.closeButtonTestId,
    other = __rest(_a, ["variant", "children", "onClose", "testId", "closeButtonTestId"]);
  var classes = useStyles();
  return React__default.createElement(Snackbar, __assign({
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    "data-testid": testId
  }, other), React__default.createElement(SnackbarContent, {
    className: classes[variant],
    "aria-describedby": "client-alert",
    message: React__default.createElement(Typography, {
      id: "client-alert",
      className: classes.message
    }, React__default.createElement(NotificationsActiveTwoTone, {
      className: classes.icon
    }), children),
    action: [React__default.createElement(IconButton$1, {
      key: "close",
      "aria-label": "close",
      color: "inherit",
      onClick: onClose,
      "data-testid": closeButtonTestId
    }, React__default.createElement(Close, null))]
  }));
};
var useStyles$1 = /*#__PURE__*/
makeStyles$1({
  root: {
    borderRadius: 3,
    display: 'flex',
    justifyContent: function justifyContent(props) {
      return props.align;
    }
  },
  message: {
    display: 'inline-block',
    textAlign: 'center'
  }
});
var AlertBanner = function AlertBanner(_a) {
  var children = _a.children,
    _b = _a.align,
    align = _b === void 0 ? 'center' : _b,
    _c = _a.severity,
    severity = _c === void 0 ? 'info' : _c,
    _d = _a.icon,
    icon = _d === void 0 ? false : _d,
    rest = __rest(_a, ["children", "align", "severity", "icon"]);
  var classes = useStyles$1({
    align: align
  });
  return createElement(Alert$1, __assign({
    classes: classes,
    severity: severity,
    icon: icon
  }, rest), children);
};
var getColor = function getColor(_a) {
  var type = _a.type;
  if (type === 'success') {
    return Liquidity.colors.feedback.success;
  } else if (type === 'warning') {
    return Liquidity.colors.feedback.warning;
  }
  return Liquidity.colors.feedback.error;
};
var useStyles$2 = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      color: Liquidity.colors.greys.background,
      backgroundColor: getColor,
      width: theme.spacing(2),
      height: theme.spacing(2),
      fontSize: 'x-small',
      fontWeight: 'bold'
    }
  };
});
var Avatar = function Avatar(props) {
  var type = props.type,
    children = props.children,
    rest = __rest(props, ["type", "children"]);
  var classes = useStyles$2(props);
  return React__default.createElement(Avatar$1, __assign({
    className: classes.root
  }, rest), children);
};

/**
 * Re-exporting as FC type in order to properly render this component in source views within Storybook.
 */

var Box = function Box(props) {
  return React__default.createElement(Box$1, __assign({}, props), props.children);
};
var StyledButton = /*#__PURE__*/
withStyles({
  root: {
    fontWeight: 600
  },
  outlinedSizeLarge: {
    fontSize: '1.125rem'
  },
  containedSizeLarge: {
    fontSize: '1.125rem'
  }
})(Button$1);
var BaseButton = /*#__PURE__*/
React__default.forwardRef(function (_a, ref) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return React__default.createElement(StyledButton, __assign({
    ref: ref,
    variant: "contained",
    color: "primary"
  }, props), children);
});
/**
 * -- exporting as typeof MaterialButton --
 * Fixes an issue where typescript doesn't recognize the component={}
 * prop on the component when we do the override above. Easiest
 * fix is to have it export as the exact same type that material-ui
 * exports it as.
 */

var Button = BaseButton;

// keys expected to be a substring of one of the values of
// PopperPlacementType

var transitionMap = /*#__PURE__*/
new Map([['bottom', 'center top'], ['left', 'right center'], ['right', 'left center'], ['top', 'center bottom']]);
var DropdownContext = /*#__PURE__*/
React__default.createContext(null);
/**
 * Wrapper component around MUI MenuItem.
 * Provides default behavior of MenuItem, but ensures it can close the wrapping menu if desired.
 */

var ButtonDropdownItem = /*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  var dropdownContext = useContext(DropdownContext);
  var wrappedOnClick = function wrappedOnClick(event) {
    if (props.onClick) {
      props.onClick(event);
    }
    if (dropdownContext && dropdownContext.closeOnItemClick) {
      dropdownContext.close();
    }
  };
  return React__default.createElement(MenuItem, __assign({}, props, {
    ref: ref,
    button: true,
    onClick: wrappedOnClick
  }), props.children);
});
var useStyles$3 = /*#__PURE__*/
makeStyles$1(function () {
  return {
    dropdownRoot: {
      zIndex: 1300
    }
  };
});
/**
 * ButtonDropdown
 * Largely a parameterized wrapper of the snippet shown here by MUI: https://material-ui.com/components/menus/#menulist-composition
 * It differs from the core Menu component in that it uses <Popper> instead of <Popover> which allows for:
 * 1. Easier relative positioning
 * 2. No blocking of scroll.
 */

function ButtonDropdown(_a) {
  var _b = _a.placement,
    menuPlacement = _b === void 0 ? 'bottom' : _b,
    label = _a.label,
    _c = _a.closeOnItemClick,
    closeOnItemClick = _c === void 0 ? true : _c,
    children = _a.children,
    btnProps = __rest(_a, ["placement", "label", "closeOnItemClick", "children"]);
  var classes = useStyles$3();
  var _d = React__default.useState(false),
    open = _d[0],
    setOpen = _d[1];
  var btnRef = React__default.useRef(null);
  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  } // return focus to the button when we transitioned from open -> !open

  var prevOpen = React__default.useRef(open);
  React__default.useEffect(function () {
    // if the dropdown was open, and now it's not, focus the button.
    if (prevOpen.current === true && open === false) {
      // eslint-disable-next-line
      btnRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]); // ensure grow transition origin is appropriate for direction

  var mapTransitionToPlacement = function mapTransitionToPlacement(placement) {
    return transitionMap.get(placement.split('-')[0]);
  };
  var idLabel = useId();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Button, __assign({
    ref: btnRef,
    "aria-haspopup": "true",
    "aria-controls": open ? "button-dropdown-" + idLabel : undefined,
    onClick: handleToggle
  }, btnProps), label), React__default.createElement(Popper, {
    open: open,
    anchorEl: btnRef.current,
    role: undefined,
    transition: true,
    disablePortal: true,
    placement: menuPlacement,
    className: classes.dropdownRoot
  }, function (_a) {
    var TransitionProps = _a.TransitionProps,
      placement = _a.placement;
    return React__default.createElement(Grow, __assign({}, TransitionProps, {
      style: {
        transformOrigin: mapTransitionToPlacement(placement)
      }
    }), React__default.createElement(Paper, null, React__default.createElement(DropdownContext.Provider, {
      value: {
        close: handleClose,
        closeOnItemClick: closeOnItemClick
      }
    }, React__default.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, React__default.createElement(MenuList, {
      autoFocusItem: open,
      id: open ? "button-dropdown-" + idLabel : undefined,
      onKeyDown: handleListKeyDown
    }, children)))));
  }));
}
function withDefaults(Component, defaultProps) {
  if (defaultProps === void 0) {
    defaultProps = {};
  }
  return function (props) {
    return React__default.createElement(Component, __assign({}, defaultProps, props));
  };
}
var Checkbox = /*#__PURE__*/
withStyles$1({
  root: {
    color: Liquidity.colors.greys.form
  },
  disabled: {
    color: Liquidity.colors.greys.light
  },
  indeterminate: {
    color: Liquidity.colors.greys.form,
    '&$disabled': {
      color: Liquidity.colors.greys.light
    }
  },
  checked: {
    color: Liquidity.colors.main.brightBlue,
    '&$disabled': {
      color: Liquidity.colors.greys.light
    }
  },
  colorPrimary: {
    '&$disabled': {
      color: Liquidity.colors.greys.light
    },
    '&$checked': {
      color: Liquidity.colors.main.primary,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    }
  },
  colorSecondary: {
    '&$disabled': {
      color: Liquidity.colors.greys.light
    },
    '&$checked': {
      color: Liquidity.colors.main.secondary,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    }
  }
})( /*#__PURE__*/
withDefaults(Checkbox$1, {
  color: 'default'
}));
var StyledChip = /*#__PURE__*/
withStyles$1(function (theme) {
  return {
    root: {
      color: Liquidity.colors.greys.base,
      backgroundColor: fade(Liquidity.colors.greys.mid, 0.25),
      border: "2px solid #FFFFFF",
      borderRadius: '13.5px',
      height: 'auto',
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(14)
    },
    disabled: {
      color: Liquidity.colors.greys.base
    },
    colorPrimary: {
      color: Liquidity.colors.text.inverse,
      backgroundColor: Liquidity.colors.main.primary,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    },
    colorSecondary: {
      color: Liquidity.colors.text.inverse,
      backgroundColor: Liquidity.colors.main.brightBlue,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    },
    deleteIcon: {
      height: 16
    }
  };
})( /*#__PURE__*/
withDefaults(Chip$1, {
  color: 'default'
}));
var useStyles$4 = /*#__PURE__*/
makeStyles$1({
  colorSecondaryDarker: {
    backgroundColor: Liquidity.colors.main.darkBlue,
    color: Liquidity.colors.text.inverse
  }
}, {
  name: 'ChipOverrides'
});
function Chip(props) {
  var classes = useStyles$4();
  var color = props.color,
    className = props.className,
    forwardedProps = __rest(props, ["color", "className"]);
  var forwardedColor = color;
  if (color === 'secondary-darker') {
    forwardedColor = 'secondary';
  }
  /**
   * This is safe because the only invariant mui does not like is
   * "secondary-darker", which we translate into "secondary" above.
   */

  forwardedColor = forwardedColor;
  return React__default.createElement(StyledChip, __assign({}, forwardedProps, {
    color: forwardedColor,
    className: clsx(className, color === 'secondary-darker' && classes.colorSecondaryDarker)
  }));
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var _ref = /*#__PURE__*/
React__default.createElement("path", {
  d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
});
function SvgAdd(props) {
  return React__default.createElement("svg", _extends({
    viewBox: "0 0 384 512"
  }, props), _ref);
}
function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var _ref$1 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"
});
function SvgAngleDown(props) {
  return React__default.createElement("svg", _extends$1({
    viewBox: "0 0 256 512"
  }, props), _ref$1);
}
function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var _ref$2 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"
});
function SvgAngleLeft(props) {
  return React__default.createElement("svg", _extends$2({
    viewBox: "0 0 192 512"
  }, props), _ref$2);
}
function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
var _ref$3 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"
});
function SvgAngleRight(props) {
  return React__default.createElement("svg", _extends$3({
    viewBox: "0 0 192 512"
  }, props), _ref$3);
}
function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var _ref$4 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"
});
function SvgAngleUp(props) {
  return React__default.createElement("svg", _extends$4({
    viewBox: "0 0 256 512"
  }, props), _ref$4);
}
function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
var _ref$5 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M443.5 248.5l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L241 419.9V44c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v375.9L28.5 241.4c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.8 4.8-12.3.1-17z"
});
function SvgArrowDown(props) {
  return React__default.createElement("svg", _extends$5({
    viewBox: "0 0 448 512"
  }, props), _ref$5);
}
function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
var _ref$6 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
});
function SvgArrowRight(props) {
  return React__default.createElement("svg", _extends$6({
    viewBox: "0 0 448 512"
  }, props), _ref$6);
}
function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
var _ref$7 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
});
function SvgArrowLeft(props) {
  return React__default.createElement("svg", _extends$7({
    viewBox: "0 0 448 512"
  }, props), _ref$7);
}
function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
var _ref$8 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M4.465 263.536l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L207 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l178.494 178.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.05c-4.686-4.686-12.284-4.686-16.971 0L4.465 246.566c-4.687 4.686-4.687 12.284 0 16.97z"
});
function SvgArrowUp(props) {
  return React__default.createElement("svg", _extends$8({
    viewBox: "0 0 448 512"
  }, props), _ref$8);
}
function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
var _ref$9 = /*#__PURE__*/
React__default.createElement("path", {
  d: "M442 114H6a6 6 0 01-6-6V84a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6zm0 160H6a6 6 0 01-6-6v-24a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6zm0 160H6a6 6 0 01-6-6v-24a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6z"
});
function SvgBars(props) {
  return React__default.createElement("svg", _extends$9({
    viewBox: "0 0 448 512"
  }, props), _ref$9);
}
function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$a.apply(this, arguments);
}
var _ref$a = /*#__PURE__*/
React__default.createElement("path", {
  d: "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.3 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36zM140.3 436.9l33.5-141.6 9.3-39.4h-150L63 32h125.9l-38.7 118-13.8 42h145.7L140.3 436.9z"
});
function SvgBolt(props) {
  return React__default.createElement("svg", _extends$a({
    viewBox: "0 0 320 512"
  }, props), _ref$a);
}
function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$b.apply(this, arguments);
}
var _ref$b = /*#__PURE__*/
React__default.createElement("path", {
  d: "M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16z"
});
function SvgCalendar(props) {
  return React__default.createElement("svg", _extends$b({
    viewBox: "0 0 448 512"
  }, props), _ref$b);
}
function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
var _ref$c = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z"
});
function SvgClock(props) {
  return React__default.createElement("svg", _extends$c({
    viewBox: "0 0 512 512"
  }, props), _ref$c);
}
function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
var _ref$d = /*#__PURE__*/
React__default.createElement("path", {
  d: "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"
});
function SvgCheck(props) {
  return React__default.createElement("svg", _extends$d({
    viewBox: "0 0 448 512"
  }, props), _ref$d);
}
function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$e.apply(this, arguments);
}
var _ref$e = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"
});
function SvgCheckCircle(props) {
  return React__default.createElement("svg", _extends$e({
    viewBox: "0 0 512 512"
  }, props), _ref$e);
}
function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$f.apply(this, arguments);
}
var _ref$f = /*#__PURE__*/
React__default.createElement("path", {
  d: "M482.696 299.276l-32.61-18.827a195.168 195.168 0 000-48.899l32.61-18.827c9.576-5.528 14.195-16.902 11.046-27.501-11.214-37.749-31.175-71.728-57.535-99.595-7.634-8.07-19.817-9.836-29.437-4.282l-32.562 18.798a194.125 194.125 0 00-42.339-24.48V38.049c0-11.13-7.652-20.804-18.484-23.367-37.644-8.909-77.118-8.91-114.77 0-10.831 2.563-18.484 12.236-18.484 23.367v37.614a194.101 194.101 0 00-42.339 24.48L105.23 81.345c-9.621-5.554-21.804-3.788-29.437 4.282-26.36 27.867-46.321 61.847-57.535 99.595-3.149 10.599 1.47 21.972 11.046 27.501l32.61 18.827a195.168 195.168 0 000 48.899l-32.61 18.827c-9.576 5.528-14.195 16.902-11.046 27.501 11.214 37.748 31.175 71.728 57.535 99.595 7.634 8.07 19.817 9.836 29.437 4.283l32.562-18.798a194.08 194.08 0 0042.339 24.479v37.614c0 11.13 7.652 20.804 18.484 23.367 37.645 8.909 77.118 8.91 114.77 0 10.831-2.563 18.484-12.236 18.484-23.367v-37.614a194.138 194.138 0 0042.339-24.479l32.562 18.798c9.62 5.554 21.803 3.788 29.437-4.283 26.36-27.867 46.321-61.847 57.535-99.595 3.149-10.599-1.47-21.972-11.046-27.501zm-65.479 100.461l-46.309-26.74c-26.988 23.071-36.559 28.876-71.039 41.059v53.479a217.145 217.145 0 01-87.738 0v-53.479c-33.621-11.879-43.355-17.395-71.039-41.059l-46.309 26.74c-19.71-22.09-34.689-47.989-43.929-75.958l46.329-26.74c-6.535-35.417-6.538-46.644 0-82.079l-46.329-26.74c9.24-27.969 24.22-53.869 43.929-75.969l46.309 26.76c27.377-23.434 37.063-29.065 71.039-41.069V44.464a216.79 216.79 0 0187.738 0v53.479c33.978 12.005 43.665 17.637 71.039 41.069l46.309-26.76c19.709 22.099 34.689 47.999 43.929 75.969l-46.329 26.74c6.536 35.426 6.538 46.644 0 82.079l46.329 26.74c-9.24 27.968-24.219 53.868-43.929 75.957zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
});
function SvgCog(props) {
  return React__default.createElement("svg", _extends$f({
    viewBox: "0 0 512 512"
  }, props), _ref$f);
}
function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$g.apply(this, arguments);
}
var _ref$g = /*#__PURE__*/
React__default.createElement("path", {
  d: "M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z"
});
function SvgEllipsisV(props) {
  return React__default.createElement("svg", _extends$g({
    viewBox: "0 0 64 512"
  }, props), _ref$g);
}
function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$h.apply(this, arguments);
}
var _ref$h = /*#__PURE__*/
React__default.createElement("path", {
  d: "M288 288a64 64 0 000-128c-1 0-1.88.24-2.85.29a47.5 47.5 0 01-60.86 60.86c0 1-.29 1.88-.29 2.85a64 64 0 0064 64zm284.52-46.6C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 96a128 128 0 11-128 128A128.14 128.14 0 01288 96zm0 320c-107.36 0-205.46-61.31-256-160a294.78 294.78 0 01129.78-129.33C140.91 153.69 128 187.17 128 224a160 160 0 00320 0c0-36.83-12.91-70.31-33.78-97.33A294.78 294.78 0 01544 256c-50.53 98.69-148.64 160-256 160z"
});
function SvgEye(props) {
  return React__default.createElement("svg", _extends$h({
    viewBox: "0 0 576 512"
  }, props), _ref$h);
}
function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$i.apply(this, arguments);
}
var _ref$i = /*#__PURE__*/
React__default.createElement("path", {
  d: "M479.968 0H32.038C3.613 0-10.729 34.487 9.41 54.627L192 237.255V424a31.996 31.996 0 0010.928 24.082l64 55.983c20.438 17.883 53.072 3.68 53.072-24.082V237.255L502.595 54.627C522.695 34.528 508.45 0 479.968 0zM288 224v256l-64-56V224L32 32h448L288 224z"
});
function SvgFilter(props) {
  return React__default.createElement("svg", _extends$i({
    viewBox: "0 0 512 512"
  }, props), _ref$i);
}
function _extends$j() {
  _extends$j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$j.apply(this, arguments);
}
var _ref$j = /*#__PURE__*/
React__default.createElement("path", {
  d: "M20 24h10c6.627 0 12 5.373 12 12v94.625C85.196 57.047 165.239 7.715 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.834 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l7.069-7.069c4.503-4.503 11.749-4.714 16.482-.454C150.782 449.238 200.935 470 256 470c117.744 0 214-95.331 214-214 0-117.744-95.331-214-214-214-82.862 0-154.737 47.077-190.289 116H164c6.627 0 12 5.373 12 12v10c0 6.627-5.373 12-12 12H20c-6.627 0-12-5.373-12-12V36c0-6.627 5.373-12 12-12zm321.647 315.235l4.706-6.47c3.898-5.36 2.713-12.865-2.647-16.763L272 263.853V116c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v164.147l84.884 61.734c5.36 3.899 12.865 2.714 16.763-2.646z"
});
function SvgHistory(props) {
  return React__default.createElement("svg", _extends$j({
    viewBox: "0 0 512 512"
  }, props), _ref$j);
}
function _extends$k() {
  _extends$k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$k.apply(this, arguments);
}
var _ref$k = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
});
function SvgInfoCircle(props) {
  return React__default.createElement("svg", _extends$k({
    viewBox: "0 0 512 512"
  }, props), _ref$k);
}
function _extends$l() {
  _extends$l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$l.apply(this, arguments);
}
var _ref$l = /*#__PURE__*/
React__default.createElement("path", {
  d: "M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z"
});
function SvgLongArrowDown(props) {
  return React__default.createElement("svg", _extends$l({
    viewBox: "0 0 256 512"
  }, props), _ref$l);
}
function _extends$m() {
  _extends$m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$m.apply(this, arguments);
}
var _ref$m = /*#__PURE__*/
React__default.createElement("path", {
  d: "M3.515 168.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L111 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l83.444 83.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-116-116.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 152c-4.687 4.686-4.687 12.284 0 16.97z"
});
function SvgLongArrowUp(props) {
  return React__default.createElement("svg", _extends$m({
    viewBox: "0 0 256 512"
  }, props), _ref$m);
}
function _extends$n() {
  _extends$n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$n.apply(this, arguments);
}
var _ref$n = /*#__PURE__*/
React__default.createElement("path", {
  d: "M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zm-95.196 140.45L174 420.745V386h-48v-48H91.255l224.059-224.059 82.745 82.745zM126.147 468.598l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"
});
function SvgPencil(props) {
  return React__default.createElement("svg", _extends$n({
    viewBox: "0 0 512 512"
  }, props), _ref$n);
}
function _extends$o() {
  _extends$o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$o.apply(this, arguments);
}
var _ref$o = /*#__PURE__*/
React__default.createElement("path", {
  d: "M512 256c0 88.225-71.775 160-160 160H110.628l68.201 68.201c4.686 4.686 4.686 12.284 0 16.971l-5.656 5.656c-4.686 4.686-12.284 4.686-16.971 0l-98.343-98.343c-4.686-4.686-4.686-12.284 0-16.971l98.343-98.343c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971L110.628 384H352c70.579 0 128-57.421 128-128 0-28.555-9.403-54.952-25.271-76.268-3.567-4.792-3.118-11.462 1.106-15.686l5.705-5.705c5.16-5.16 13.678-4.547 18.083 1.271C499.935 186.438 512 219.835 512 256zM57.271 332.268C41.403 310.952 32 284.555 32 256c0-70.579 57.421-128 128-128h241.372l-68.201 68.201c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.686 12.284 4.686 16.971 0l98.343-98.343c4.686-4.686 4.686-12.284 0-16.971L355.799 5.172c-4.686-4.686-12.284-4.686-16.971 0l-5.656 5.656c-4.686 4.686-4.686 12.284 0 16.971L401.372 96H160C71.775 96 0 167.775 0 256c0 36.165 12.065 69.562 32.376 96.387 4.405 5.818 12.923 6.432 18.083 1.271l5.705-5.705c4.225-4.224 4.674-10.893 1.107-15.685z"
});
function SvgRepeat(props) {
  return React__default.createElement("svg", _extends$o({
    viewBox: "0 0 512 512"
  }, props), _ref$o);
}
function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$p.apply(this, arguments);
}
var _ref$p = /*#__PURE__*/
React__default.createElement("path", {
  d: "M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
});
function SvgSearch(props) {
  return React__default.createElement("svg", _extends$p({
    viewBox: "0 0 512 512"
  }, props), _ref$p);
}
function _extends$q() {
  _extends$q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$q.apply(this, arguments);
}
var _ref$q = /*#__PURE__*/
React__default.createElement("path", {
  d: "M376 288H264a8 8 0 00-8 8v16a8 8 0 008 8h112a8 8 0 008-8v-16a8 8 0 00-8-8zm-64 96h-48a8 8 0 00-8 8v16a8 8 0 008 8h48a8 8 0 008-8v-16a8 8 0 00-8-8zM504 96H264a8 8 0 00-8 8v16a8 8 0 008 8h240a8 8 0 008-8v-16a8 8 0 00-8-8zm-64 96H264a8 8 0 00-8 8v16a8 8 0 008 8h176a8 8 0 008-8v-16a8 8 0 00-8-8zM198.93 371.56a11.93 11.93 0 00-16.91-.09l-54 52.67V40a8 8 0 00-8-8H104a8 8 0 00-8 8v383.92l-53.94-52.35a12 12 0 00-16.92 0l-5.64 5.66a12 12 0 000 17l84.06 82.3a11.94 11.94 0 0016.87 0l84-82.32a12 12 0 00.09-17z"
});
function SvgSortAmountDown(props) {
  return React__default.createElement("svg", _extends$q({
    viewBox: "0 0 512 512"
  }, props), _ref$q);
}
function _extends$r() {
  _extends$r = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$r.apply(this, arguments);
}
var _ref$r = /*#__PURE__*/
React__default.createElement("path", {
  d: "M312 384h-48a8 8 0 00-8 8v16a8 8 0 008 8h48a8 8 0 008-8v-16a8 8 0 00-8-8zm64-96H264a8 8 0 00-8 8v16a8 8 0 008 8h112a8 8 0 008-8v-16a8 8 0 00-8-8zM504 96H264a8 8 0 00-8 8v16a8 8 0 008 8h240a8 8 0 008-8v-16a8 8 0 00-8-8zm-64 96H264a8 8 0 00-8 8v16a8 8 0 008 8h176a8 8 0 008-8v-16a8 8 0 00-8-8zM120.44 35.51a11.94 11.94 0 00-16.87 0l-84 82.32a12 12 0 00-.09 17l5.61 5.68a11.93 11.93 0 0016.91.09l54-52.74V472a8 8 0 008 8h16a8 8 0 008-8V88.08l53.94 52.35a12 12 0 0016.92 0l5.64-5.66a12 12 0 000-17z"
});
function SvgSortAmountUp(props) {
  return React__default.createElement("svg", _extends$r({
    viewBox: "0 0 512 512"
  }, props), _ref$r);
}
function _extends$s() {
  _extends$s = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$s.apply(this, arguments);
}
var _ref$s = /*#__PURE__*/
React__default.createElement("path", {
  d: "M32.032 224h255.93c28.425 0 42.767-34.488 22.627-54.627l-127.962-128c-12.496-12.496-32.758-12.497-45.255 0l-127.968 128C-10.695 189.472 3.55 224 32.032 224zM160 64l128 128H32L160 64z"
});
function SvgSortUp(props) {
  return React__default.createElement("svg", _extends$s({
    viewBox: "0 0 320 512"
  }, props), _ref$s);
}
function _extends$t() {
  _extends$t = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$t.apply(this, arguments);
}
var _ref$t = /*#__PURE__*/
React__default.createElement("path", {
  d: "M492 8h-10c-6.627 0-12 5.373-12 12v110.627C426.929 57.261 347.224 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h10.016c6.353 0 11.646-4.949 11.977-11.293C48.157 132.216 141.097 42 256 42c82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-.301 248h-10.015c-6.352 0-11.647 4.949-11.977 11.293C463.841 380.158 370.546 470 256 470c-82.608 0-154.672-46.952-190.299-116H180c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H20c-6.627 0-12 5.373-12 12v160c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V381.373C85.071 454.739 164.777 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"
});
function SvgSync(props) {
  return React__default.createElement("svg", _extends$t({
    viewBox: "0 0 512 512"
  }, props), _ref$t);
}
function _extends$u() {
  _extends$u = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$u.apply(this, arguments);
}
var _ref$u = /*#__PURE__*/
React__default.createElement("path", {
  d: "M497.941 225.941L286.059 14.059A48 48 0 00252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0014.059 33.941l211.882 211.882c18.745 18.745 49.137 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zm-22.627 45.255L271.196 475.314c-6.243 6.243-16.375 6.253-22.627 0L36.686 263.431A15.895 15.895 0 0132 252.117V48c0-8.822 7.178-16 16-16h204.118c4.274 0 8.292 1.664 11.314 4.686l211.882 211.882c6.238 6.239 6.238 16.39 0 22.628zM144 124c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
});
function SvgTag(props) {
  return React__default.createElement("svg", _extends$u({
    viewBox: "0 0 512 512"
  }, props), _ref$u);
}
function _extends$v() {
  _extends$v = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$v.apply(this, arguments);
}
var _ref$v = /*#__PURE__*/
React__default.createElement("path", {
  d: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
});
function SvgTimes(props) {
  return React__default.createElement("svg", _extends$v({
    viewBox: "0 0 320 512"
  }, props), _ref$v);
}
function _extends$w() {
  _extends$w = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$w.apply(this, arguments);
}
var _ref$w = /*#__PURE__*/
React__default.createElement("path", {
  d: "M296 432h16a8 8 0 008-8V152a8 8 0 00-8-8h-16a8 8 0 00-8 8v272a8 8 0 008 8zm-160 0h16a8 8 0 008-8V152a8 8 0 00-8-8h-16a8 8 0 00-8 8v272a8 8 0 008 8zM440 64H336l-33.6-44.8A48 48 0 00264 0h-80a48 48 0 00-38.4 19.2L112 64H8a8 8 0 00-8 8v16a8 8 0 008 8h24v368a48 48 0 0048 48h288a48 48 0 0048-48V96h24a8 8 0 008-8V72a8 8 0 00-8-8zM171.2 38.4A16.1 16.1 0 01184 32h80a16.1 16.1 0 0112.8 6.4L296 64H152zM384 464a16 16 0 01-16 16H80a16 16 0 01-16-16V96h320zm-168-32h16a8 8 0 008-8V152a8 8 0 00-8-8h-16a8 8 0 00-8 8v272a8 8 0 008 8z"
});
function SvgTrashAlt(props) {
  return React__default.createElement("svg", _extends$w({
    viewBox: "0 0 448 512"
  }, props), _ref$w);
}
function _extends$x() {
  _extends$x = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$x.apply(this, arguments);
}
var _ref$x = /*#__PURE__*/
React__default.createElement("path", {
  d: "M433.941 65.941l-51.882-51.882A48 48 0 00348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 00-14.059-33.941zM352 32.491a15.88 15.88 0 017.431 4.195l51.882 51.883A15.885 15.885 0 01415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
});
function SvgCopy(props) {
  return React__default.createElement("svg", _extends$x({
    viewBox: "0 0 448 512"
  }, props), _ref$x);
}
function _extends$y() {
  _extends$y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$y.apply(this, arguments);
}
var _ref$y = /*#__PURE__*/
React__default.createElement("path", {
  d: "M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h99.4L87 263.6c-25.2-25.2-7.3-68.3 28.3-68.3H168V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v155.3h52.7c35.6 0 53.4 43.1 28.3 68.3L368.6 320H468c24.3 0 44 19.7 44 44zm-261.7 17.7c3.1 3.1 8.2 3.1 11.3 0L402.3 241c5-5 1.5-13.7-5.7-13.7H312V40c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v187.3h-84.7c-7.1 0-10.7 8.6-5.7 13.7l140.7 140.7zM480 364c0-6.6-5.4-12-12-12H336.6l-52.3 52.3c-15.6 15.6-41 15.6-56.6 0L175.4 352H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"
});
function SvgDownload(props) {
  return React__default.createElement("svg", _extends$y({
    viewBox: "0 0 512 512"
  }, props), _ref$y);
}
function _extends$z() {
  _extends$z = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$z.apply(this, arguments);
}
var _ref$z = /*#__PURE__*/
React__default.createElement("path", {
  d: "M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h124v-99.3h-52.7c-35.6 0-53.4-43.1-28.3-68.3L227.7 11.7c15.6-15.6 40.9-15.6 56.6 0L425 152.4c25.2 25.2 7.3 68.3-28.3 68.3H344V320h124c24.3 0 44 19.7 44 44zM200 188.7V376c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8V188.7h84.7c7.1 0 10.7-8.6 5.7-13.7L261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0L109.7 175c-5 5-1.5 13.7 5.7 13.7H200zM480 364c0-6.6-5.4-12-12-12H344v24c0 22.1-17.9 40-40 40h-96c-22.1 0-40-17.9-40-40v-24H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"
});
function SvgUpload(props) {
  return React__default.createElement("svg", _extends$z({
    viewBox: "0 0 512 512"
  }, props), _ref$z);
}
function _extends$A() {
  _extends$A = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$A.apply(this, arguments);
}
var _ref$A = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zM103.265 408.735c-80.622-80.622-84.149-208.957-10.9-293.743l304.644 304.643c-84.804 73.264-213.138 69.706-293.744-10.9zm316.37-11.727L114.992 92.365c84.804-73.263 213.137-69.705 293.743 10.9 80.622 80.621 84.149 208.957 10.9 293.743z"
});
function SvgBan(props) {
  return React__default.createElement("svg", _extends$A({
    viewBox: "0 0 512 512"
  }, props), _ref$A);
}
function _extends$B() {
  _extends$B = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$B.apply(this, arguments);
}
var _ref$B = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"
});
function SvgExclamationCircle(props) {
  return React__default.createElement("svg", _extends$B({
    viewBox: "0 0 512 512"
  }, props), _ref$B);
}
function _extends$C() {
  _extends$C = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$C.apply(this, arguments);
}
var _ref$C = /*#__PURE__*/
React__default.createElement("path", {
  d: "M219.5 320h9c6.4 0 11.7-5.1 12-11.5l7-168c.3-6.8-5.2-12.5-12-12.5h-23c-6.8 0-12.3 5.7-12 12.5l7 168c.3 6.4 5.6 11.5 12 11.5zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16zm-192-92c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28z"
});
function SvgExclamationSquare(props) {
  return React__default.createElement("svg", _extends$C({
    viewBox: "0 0 448 512"
  }, props), _ref$C);
}
function _extends$D() {
  _extends$D = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$D.apply(this, arguments);
}
var _ref$D = /*#__PURE__*/
React__default.createElement("path", {
  d: "M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"
});
function SvgExclamationTriangle(props) {
  return React__default.createElement("svg", _extends$D({
    viewBox: "0 0 576 512"
  }, props), _ref$D);
}
function _extends$E() {
  _extends$E = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$E.apply(this, arguments);
}
var _ref$E = /*#__PURE__*/
React__default.createElement("path", {
  d: "M224 420c-11 0-20-9-20-20v-64c0-11 9-20 20-20s20 9 20 20v64c0 11-9 20-20 20zm224-148v192c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48h16v-64C64 71.6 136-.3 224.5 0 312.9.3 384 73.1 384 161.5V224h16c26.5 0 48 21.5 48 48zM96 224h256v-64c0-70.6-57.4-128-128-128S96 89.4 96 160v64zm320 240V272c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16z"
});
function SvgLockAlt(props) {
  return React__default.createElement("svg", _extends$E({
    viewBox: "0 0 448 512"
  }, props), _ref$E);
}
function _extends$F() {
  _extends$F = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$F.apply(this, arguments);
}
var _ref$F = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"
});
function SvgQuestionCircle(props) {
  return React__default.createElement("svg", _extends$F({
    viewBox: "0 0 512 512"
  }, props), _ref$F);
}
function _extends$G() {
  _extends$G = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$G.apply(this, arguments);
}
var _ref$G = /*#__PURE__*/
React__default.createElement("path", {
  d: "M312.5 168.5c-4.7-4.7-12.3-4.7-17 0l-98.3 98.3c-4.7 4.7-4.7 12.3 0 17l5.7 5.7c4.7 4.7 12.3 4.7 17 0l68.2-68.2V372c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V221.3l68.2 68.2c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17l-98.5-98.3zm259.2 70.3c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96z"
});
function SvgCloudUpload(props) {
  return React__default.createElement("svg", _extends$G({
    viewBox: "0 0 640 512"
  }, props), _ref$G);
}
function _extends$H() {
  _extends$H = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$H.apply(this, arguments);
}
var _ref$H = /*#__PURE__*/
React__default.createElement("path", {
  d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
});
function SvgTimesCircle(props) {
  return React__default.createElement("svg", _extends$H({
    viewBox: "0 0 512 512"
  }, props), _ref$H);
}
function _extends$I() {
  _extends$I = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$I.apply(this, arguments);
}
var _ref$I = /*#__PURE__*/
React__default.createElement("path", {
  d: "M464 64c8.823 0 16 7.178 16 16v352c0 8.822-7.177 16-16 16H48c-8.823 0-16-7.178-16-16V80c0-8.822 7.177-16 16-16h416m0-32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-336 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm288-148v-24a6 6 0 00-6-6H198a6 6 0 00-6 6v24a6 6 0 006 6h212a6 6 0 006-6zm0 96v-24a6 6 0 00-6-6H198a6 6 0 00-6 6v24a6 6 0 006 6h212a6 6 0 006-6zm0 96v-24a6 6 0 00-6-6H198a6 6 0 00-6 6v24a6 6 0 006 6h212a6 6 0 006-6z"
});
function SvgListAlt(props) {
  return React__default.createElement("svg", _extends$I({
    viewBox: "0 0 512 512"
  }, props), _ref$I);
}
function _extends$J() {
  _extends$J = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$J.apply(this, arguments);
}
var _ref$J = /*#__PURE__*/
React__default.createElement("path", {
  d: "M566.819 227.377L462.377 83.768A48.001 48.001 0 00423.557 64H152.443a47.998 47.998 0 00-38.819 19.768L9.181 227.377A47.996 47.996 0 000 255.609V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V255.609a47.996 47.996 0 00-9.181-28.232zM139.503 102.589A16.048 16.048 0 01152.443 96h271.115c5.102 0 9.939 2.463 12.94 6.589L524.796 224H388.223l-32 64H219.777l-32-64H51.204l88.299-121.411zM544 272v128c0 8.823-7.178 16-16 16H48c-8.822 0-16-7.177-16-16V272c0-8.837 7.163-16 16-16h120l32 64h176l32-64h120c8.837 0 16 7.163 16 16z"
});
function SvgInbox(props) {
  return React__default.createElement("svg", _extends$J({
    viewBox: "0 0 576 512"
  }, props), _ref$J);
}
function buildSVGIcon(component, viewBox) {
  return function (props) {
    return React__default.createElement(SvgIcon, __assign({}, props, {
      component: component,
      viewBox: viewBox
    }));
  };
}
var AddIcon = /*#__PURE__*/
buildSVGIcon(SvgAdd, '0 0 384 512');
var AngleDownIcon = /*#__PURE__*/
buildSVGIcon(SvgAngleDown, '0 0 256 512');
var AngleLeftIcon = /*#__PURE__*/
buildSVGIcon(SvgAngleLeft, '0 0 192 512');
var AngleRightIcon = /*#__PURE__*/
buildSVGIcon(SvgAngleRight, '0 0 192 512');
var AngleUpIcon = /*#__PURE__*/
buildSVGIcon(SvgAngleUp, '0 0 256 512');
var ArrowDropUpIcon = /*#__PURE__*/
buildSVGIcon(SvgSortUp, '0 0 320 512');
var ArrowDownIcon = /*#__PURE__*/
buildSVGIcon(SvgArrowDown, '0 0 448 512');
var ArrowLeftIcon = /*#__PURE__*/
buildSVGIcon(SvgArrowLeft, '0 0 448 512');
var ArrowRightIcon = /*#__PURE__*/
buildSVGIcon(SvgArrowRight, '0 0 448 512');
var ArrowUpIcon = /*#__PURE__*/
buildSVGIcon(SvgArrowUp, '0 0 448 512');
var BarsIcon = /*#__PURE__*/
buildSVGIcon(SvgBars, '0 0 448 512');
var BoltIcon = /*#__PURE__*/
buildSVGIcon(SvgBolt, '0 0 256 512');
var CalendarIcon = /*#__PURE__*/
buildSVGIcon(SvgCalendar, '0 0 512 512');
var ClockIcon = /*#__PURE__*/
buildSVGIcon(SvgClock, '0 0 512 512');
var CloseIcon = /*#__PURE__*/
buildSVGIcon(SvgTimes, '0 0 320 512');
var CheckIcon = /*#__PURE__*/
buildSVGIcon(SvgCheck, '0 0 320 512');
var CheckCircleIcon = /*#__PURE__*/
buildSVGIcon(SvgCheckCircle, '0 0 512 512');
var CogIcon = /*#__PURE__*/
buildSVGIcon(SvgCog, '0 0 512 512');
var EyeIcon = /*#__PURE__*/
buildSVGIcon(SvgEye, '0 0 576 512');
var FilterIcon = /*#__PURE__*/
buildSVGIcon(SvgFilter, '0 0 512 512');
var InfoIcon = /*#__PURE__*/
buildSVGIcon(SvgInfoCircle, '0 0 512 512');
var HistoryIcon = /*#__PURE__*/
buildSVGIcon(SvgHistory, '0 0 512 512');
var LongArrowDownIcon = /*#__PURE__*/
buildSVGIcon(SvgLongArrowDown, '0 0 256 512');
var LongArrowUpIcon = /*#__PURE__*/
buildSVGIcon(SvgLongArrowUp, '0 0 256 512');
var MoreVertIcon = /*#__PURE__*/
buildSVGIcon(SvgEllipsisV, '0 0 64 512');
var PencilIcon = /*#__PURE__*/
buildSVGIcon(SvgPencil, '0 0 512 512');
var RepeatingIcon = /*#__PURE__*/
buildSVGIcon(SvgRepeat, '0 0 512 512');
var SearchIcon = /*#__PURE__*/
buildSVGIcon(SvgSearch, '0 0 512 512');
var SortAmountDownIcon = /*#__PURE__*/
buildSVGIcon(SvgSortAmountDown, '0 0 512 512');
var SortAmountUpIcon = /*#__PURE__*/
buildSVGIcon(SvgSortAmountUp, '0 0 512 512');
var SyncIcon = /*#__PURE__*/
buildSVGIcon(SvgSync, '0 0 512 512');
var TagIcon = /*#__PURE__*/
buildSVGIcon(SvgTag, '0 0 512 512');
var TrashIcon = /*#__PURE__*/
buildSVGIcon(SvgTrashAlt, '0 0 448 512');
var CopyIcon = /*#__PURE__*/
buildSVGIcon(SvgCopy, '0 0 448 512');
var DownloadIcon = /*#__PURE__*/
buildSVGIcon(SvgDownload, '0 0 512 512');
var UploadIcon = /*#__PURE__*/
buildSVGIcon(SvgUpload, '0 0 512 512');
var BanIcon = /*#__PURE__*/
buildSVGIcon(SvgBan, '0 0 512 512');
var ExclamationCircleIcon = /*#__PURE__*/
buildSVGIcon(SvgExclamationCircle, '0 0 512 512');
var ExclamationSquareIcon = /*#__PURE__*/
buildSVGIcon(SvgExclamationSquare, '0 0 448 512');
var ExclamationTriangleIcon = /*#__PURE__*/
buildSVGIcon(SvgExclamationTriangle, '0 0 576 512');
var LockAltIcon = /*#__PURE__*/
buildSVGIcon(SvgLockAlt, '0 0 448 512');
var QuestionCircleIcon = /*#__PURE__*/
buildSVGIcon(SvgQuestionCircle, '0 0 512 512');
var CloudUploadIcon = /*#__PURE__*/
buildSVGIcon(SvgCloudUpload, '0 0 640 512');
var TimesCircleIcon = /*#__PURE__*/
buildSVGIcon(SvgTimesCircle, '0 0 512 512');
var ListAltIcon = /*#__PURE__*/
buildSVGIcon(SvgListAlt, '0 0 512 512');
var InboxIcon = /*#__PURE__*/
buildSVGIcon(SvgInbox, '0 0 576 512');
var IconButton = /*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  return React__default.createElement(MaterialIconButton, __assign({
    color: "primary"
  }, props, {
    ref: ref
  }), props.children);
});
function BaseLink(props) {
  return React__default.createElement(Link$1, __assign({
    color: 'secondary'
  }, props));
}
/**
 * Fixes an issue where typescript doesn't recognize the component={}
 * prop on the component when we do the override above. Easiest
 * fix is to have it export as the exact same type that material-ui
 * exports it as.
 */

var Link = BaseLink;
var colors = {
  primary: '#095540',
  secondary: '#6BA43A',
  black: '#000000',
  white: '#ffffff'
};
var Logo = function Logo(props) {
  var height = props.height,
    width = props.width,
    className = props.className,
    color = props.color;
  var fill = color && colors[color] || colors.primary;
  var fillSecondary = colors.secondary;
  return React__default.createElement("svg", {
    viewBox: "0 0 78.17 18.88",
    className: className,
    height: height,
    width: width
  }, React__default.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    fill: fillSecondary,
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M21.94,8.13a1.48,1.48,0,0,1,0,2.1l-1.7,1.7a3.25,3.25,0,0,1-4.61,0l2.75-2.75L12.54,3.34a1.48,1.48,0,0,0-2.1,0L4.31,9.46a1.48,1.48,0,0,0,0,2.1L12,19.29H8.71a3.15,3.15,0,0,1-2.2-.91L1,12.82A3.25,3.25,0,0,1,1,8.21L8.32.84a1.49,1.49,0,0,1,1-.44H13.6a1.5,1.5,0,0,1,1.06.44Z",
    transform: "translate(0 -0.4)"
  })), React__default.createElement("path", {
    fill: fillSecondary,
    d: "M20.47,19.29a1.5,1.5,0,0,0,1.06-.44l7.36-7.37a3.25,3.25,0,0,0,0-4.61L23.33,1.31A3.1,3.1,0,0,0,21.14.4H17.81l7.72,7.73a1.48,1.48,0,0,1,0,2.1l-6.12,6.12a1.48,1.48,0,0,1-2.1,0l-5.84-5.84,2.75-2.75a3.25,3.25,0,0,0-4.61,0l-.45.45L7.91,9.46a1.47,1.47,0,0,0,0,2.1l1.25,1.26,6,6a1.49,1.49,0,0,0,1,.44Z",
    transform: "translate(0 -0.4)"
  }), React__default.createElement("path", {
    d: "M45.17,13a6.13,6.13,0,1,1-.23-6.78L42.67,7.8a3.37,3.37,0,1,0,.19,3.71Z",
    transform: "translate(0 -0.4)"
  }), React__default.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M72,3.67A6.13,6.13,0,1,0,78.17,9.8,6.12,6.12,0,0,0,72,3.67m0,9.5A3.37,3.37,0,1,1,75.41,9.8,3.37,3.37,0,0,1,72,13.17",
    transform: "translate(0 -0.4)"
  })), React__default.createElement("polygon", {
    points: "65.26 6.14 65.26 3.43 59.79 3.43 56.59 3.43 56.59 6.14 56.59 8.22 56.59 10.89 56.59 15.36 59.73 15.36 59.73 10.89 64.06 10.89 64.06 8.22 59.73 8.22 59.73 6.14 65.26 6.14"
  }), React__default.createElement("path", {
    d: "M54.72,13.2v2.57H46.49a7.72,7.72,0,0,1-.13-1.29c0-4.39,5.14-5.17,5.14-6.88a1.18,1.18,0,0,0-1.28-1.18,2.29,2.29,0,0,0-1.77,1.26L46.29,6.23a4.59,4.59,0,0,1,4.19-2.56c2,0,4.06,1.12,4.06,3.64,0,3.66-4.64,4.41-4.87,5.89Z",
    transform: "translate(0 -0.4)"
  })));
};
var ModalContext = /*#__PURE__*/
React__default.createContext({
  isModalOpen: false,
  setModalOpen: function setModalOpen() {}
});
var modalMaxHeightDesktop = '80vh';
/**
 * we're doing a lot of unintuitive things with content padding in this modal due to "variants".
 * encapsulating that logic here for sanity:
 * @param variant - the ModalVariant being used
 * @param breakpointUp - the breakpoint (and up) that we're setting padding for
 * @param theme - theme object from material-ui
 *
 * @return the theme-adjusted padding values via `theme.spacing()`
 */

function contentPaddingByVariant(variant, theme, breakpointUp) {
  switch (variant) {
    case undefined:
      return theme.spacing(4, 3);
    case 'informational':
      if (breakpointUp === 'sm' || breakpointUp === 'md') {
        return theme.spacing(0, 5);
      } else {
        return theme.spacing(0, 1);
      }
    case 'nopaddingonmobile':
      if (!breakpointUp || breakpointUp === 'sm') {
        return theme.spacing(0, 0);
      } else {
        return theme.spacing(4, 3);
      }
  }
}
var useStyles$5 = /*#__PURE__*/
makeStyles$1(function (theme) {
  var _a, _b;
  return createStyles({
    wrapper: function wrapper(_a) {
      var _b;
      var variant = _a.variant,
        desktopWidth = _a.desktopWidth;
      return _b = {
        backgroundColor: theme.palette.background.paper,
        border: variant === 'informational' ? "5px solid " + Liquidity.colors.main.midBlue : 'none',
        borderRadius: variant === 'informational' ? '5px' : 'none',
        boxShadow: variant === 'informational' ? '0 10px 10px fade(black, 40)' : '0',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        outline: 'none',
        position: 'absolute',
        width: '100%'
      }, _b[theme.breakpoints.up('sm')] = {
        boxShadow: '0 8px 32px 0 rgba(7, 18, 37, 0.2)',
        flex: "0 1 " + modalMaxHeightDesktop,
        height: 'auto',
        left: '50%',
        maxHeight: modalMaxHeightDesktop,
        maxWidth: desktopWidth === 'normal' ? 650 : 850,
        top: '10vh',
        transform: 'translate(-50%, 0)',
        width: '90%'
      }, _b;
    },
    paper: (_a = {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: 1
    }, _a[theme.breakpoints.up('sm')] = {
      maxHeight: modalMaxHeightDesktop
    }, _a),
    titleBar: {
      alignItems: 'center',
      background: function background(_a) {
        var variant = _a.variant;
        return variant === 'informational' ? 'white' : Liquidity.colors.main.midBlue;
      },
      color: 'white',
      display: 'flex',
      flex: '1 0 auto',
      justifyContent: 'space-between',
      minHeight: 48,
      padding: theme.spacing(0, 2)
    },
    emptyTitleBar: {
      paddingBottom: theme.spacing(1)
    },
    title: function title(_a) {
      var variant = _a.variant;
      return {
        color: variant === 'informational' ? Liquidity.colors.main.midBlue : 'white',
        textAlign: variant === 'informational' ? 'center' : 'left',
        fontSize: variant === 'informational' ? theme.typography.pxToRem(30) : 'inherit',
        textTransform: variant === 'informational' ? 'uppercase' : 'none',
        padding: variant === 'informational' ? theme.spacing(5, 0) : '',
        fontWeight: variant === 'informational' ? 'normal' : 'bold',
        width: variant === 'informational' ? '100%' : 'inherit'
      };
    },
    content: (_b = {
      flex: '1 1 100vh',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: function padding(_a) {
        var variant = _a.variant;
        return contentPaddingByVariant(variant, theme, undefined);
      }
    }, _b[theme.breakpoints.up('sm')] = {
      flex: '1 1 auto',
      padding: function padding(_a) {
        var variant = _a.variant;
        return contentPaddingByVariant(variant, theme, 'sm');
      }
    }, _b[theme.breakpoints.up('md')] = {
      padding: function padding(_a) {
        var variant = _a.variant;
        return contentPaddingByVariant(variant, theme, 'md');
      }
    }, _b),
    backdrop: {
      // Must use !important to override background set via inline style.
      backgroundColor: Liquidity.colors.main.secondary + " !important",
      opacity: 0.7
    },
    closeIcon: function closeIcon(_a) {
      var variant = _a.variant;
      return variant === 'informational' ? {
        position: 'absolute',
        top: 0,
        right: 0,
        marginRight: 12,
        marginTop: 10,
        color: Liquidity.colors.main.midBlue
      } : {};
    },
    actions: function actions(_a) {
      var variant = _a.variant;
      return {
        alignItems: 'center',
        backgroundColor: variant === 'informational' ? 'none' : Liquidity.colors.greys.background,
        borderTop: '1px solid',
        borderTopColor: variant === 'informational' ? 'rgba(0, 0, 0, 0.12)' : Liquidity.colors.greys.light,
        display: 'flex',
        flex: '1 0 auto',
        justifyContent: 'flex-end',
        minHeight: 80,
        padding: theme.spacing(0, 2.5),
        width: '100%'
      };
    }
  });
});
var Modal = /*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  var modalTitle = props.modalTitle,
    actionsContent = props.actionsContent,
    closeButtonTestId = props.closeButtonTestId,
    _a = props.desktopWidth,
    desktopWidth = _a === void 0 ? 'normal' : _a,
    variant = props.variant,
    forwardedProps = __rest(props, ["modalTitle", "actionsContent", "closeButtonTestId", "desktopWidth", "variant"]);
  var classes = useStyles$5({
    desktopWidth: desktopWidth,
    variant: variant
  });
  var setModalOpen = useContext(ModalContext).setModalOpen;
  useEffect(function () {
    setModalOpen(forwardedProps.open);
  }, [setModalOpen, forwardedProps.open]);
  /**
   * We always want to clean up context to open = false on unmount, or
   * we risk not hiding the overlay when this component is unmounted.
   * NOTE: this useEffect should _NOT_ have any dependencies
   * as it's effectively a componentWillUnmount().
   */

  useEffect(function () {
    return function () {
      setModalOpen(false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var titleContent;
  if (typeof modalTitle === 'string') {
    titleContent = React__default.createElement(Typography, {
      component: "h1",
      variant: "body1",
      className: classes.title
    }, modalTitle);
  } else {
    titleContent = modalTitle;
  }
  /**
   * If the user doesn't give a title, nor a way to close the modal,
   * then we display an empty div to give the top of the
   * modal some extra padding
   */

  var isEmptyTitleBar = !titleContent && !forwardedProps.onClose;
  return React__default.createElement(Modal$1, __assign({
    BackdropProps: {
      className: classes.backdrop
    }
  }, forwardedProps, {
    ref: ref
  }), React__default.createElement("div", {
    className: classes.wrapper
  }, React__default.createElement("div", {
    className: classes.paper
  }, isEmptyTitleBar ? React__default.createElement("div", {
    className: classes.emptyTitleBar
  }) : React__default.createElement("div", {
    className: classes.titleBar
  }, titleContent, forwardedProps.onClose !== undefined && React__default.createElement(IconButton, {
    "aria-label": "display more actions",
    "aria-controls": "navigation-more-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return forwardedProps.onClose ? forwardedProps.onClose(event, 'backdropClick') : null;
    },
    edge: "end",
    color: "inherit",
    className: classes.closeIcon,
    "data-testid": closeButtonTestId
  }, React__default.createElement(CloseIcon, null))), React__default.createElement("div", {
    className: classes.content
  }, forwardedProps.children), actionsContent && React__default.createElement("div", {
    className: classes.actions
  }, actionsContent))));
});
function Pagination(props) {
  return React__default.createElement(Pagination$1, __assign({
    color: 'secondary',
    showFirstButton: true,
    showLastButton: true
  }, props));
}
var Radio = /*#__PURE__*/
withStyles$1({
  root: {
    color: Liquidity.colors.greys.form
  },
  disabled: {
    color: Liquidity.colors.greys.light
  },
  checked: {
    color: Liquidity.colors.main.brightBlue,
    '&$disabled': {
      color: Liquidity.colors.greys.light
    }
  },
  colorPrimary: {
    '&$disabled': {
      color: Liquidity.colors.greys.light
    },
    '&$checked': {
      color: Liquidity.colors.main.primary,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    }
  },
  colorSecondary: {
    '&$disabled': {
      color: Liquidity.colors.greys.light
    },
    '&$checked': {
      color: Liquidity.colors.main.secondary,
      '&$disabled': {
        color: Liquidity.colors.greys.light
      }
    }
  }
})( /*#__PURE__*/
withDefaults(Radio$1, {
  color: 'default'
}));
var InterFontNames = {
  normal: '"Inter"',
  "var": '"Inter var"'
};
var fontFamily = InterFontNames.normal;
var fontStyle = 'normal';
var base = 'https://rsms.me/inter/font-files';
var version = 3.11;
var InterLight = {
  fontFamily: fontFamily,
  fontStyle: fontStyle,
  fontWeight: 300,
  src: /*#__PURE__*/
  getFontFaceSrc({
    base: base,
    version: version,
    name: 'Inter-Light'
  })
};
var InterNormal = {
  fontFamily: fontFamily,
  fontStyle: fontStyle,
  fontWeight: 400,
  src: /*#__PURE__*/
  getFontFaceSrc({
    base: base,
    version: version,
    name: 'Inter-Regular'
  })
};
var InterMedium = {
  fontFamily: fontFamily,
  fontStyle: fontStyle,
  fontWeight: 500,
  src: /*#__PURE__*/
  getFontFaceSrc({
    base: base,
    version: version,
    name: 'Inter-Medium'
  })
};
var InterBold = {
  fontFamily: fontFamily,
  fontStyle: fontStyle,
  fontWeight: 700,
  src: /*#__PURE__*/
  getFontFaceSrc({
    base: base,
    version: version,
    name: 'Inter-Bold'
  })
};
var InterVar = {
  fontFamily: InterFontNames["var"],
  fontStyle: fontStyle,
  fontWeight: '100 900',
  fontDisplay: 'swap',
  fontNamedInstance: '"Regular"',
  src: /*#__PURE__*/
  getFontFaceSrc({
    base: base,
    version: version,
    name: 'Inter-roman.var'
  }, ['woff2'])
};
var Inter = [InterLight, InterNormal, InterMedium, InterBold, InterVar];
function getFontFaceSrc(props, formats) {
  if (formats === void 0) {
    formats = ['woff', 'woff2'];
  }
  return formats.map(function (format) {
    return getSingleFontFaceSrc(__assign(__assign({}, props), {
      format: format
    }));
  }).join(',');
}
function getSingleFontFaceSrc(_a) {
  var base = _a.base,
    version = _a.version,
    name = _a.name,
    format = _a.format;
  var url = normalizeUrl(base + "/" + name + "." + format + "?v=" + version);
  return "url(\"" + url + "\") format(\"" + format + "\")";
}
function normalizeUrl(url) {
  return url.replace(/([^:])\/\//g, '$1/') // replace double slashes, except starting with a colon
  .replace(/\.\./g, '.'); // replace double dots
}

var fallbackFonts = ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', '"Helvetica"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'];
var InterFontStyles = {
  fontFamily: /*#__PURE__*/
  __spreadArrays([InterFontNames.normal], fallbackFonts).join(', '),
  '@supports (font-variation-settings: normal)': {
    fontFamily: /*#__PURE__*/
    __spreadArrays([InterFontNames["var"]], fallbackFonts).join(', ')
  }
};
var overrides = {
  MuiCssBaseline: {
    '@global': {
      '@font-face': Inter,
      'input[type="search"]::-webkit-search-cancel-button': {
        '-webkit-appearance': 'none'
      },
      html: /*#__PURE__*/
      __assign({
        '-webkit-text-size-adjust': '100%'
      }, InterFontStyles)
    }
  },
  MuiTypography: {
    root: /*#__PURE__*/
    __assign({
      color: Liquidity.colors.text.standard
    }, InterFontStyles)
  },
  MuiOutlinedInput: {
    root: {
      '&.Mui-focused $notchedOutline': {
        borderColor: Liquidity.colors.main.brightBlue
      }
    }
  }
};
var C2FOTheme = /*#__PURE__*/
createMuiTheme({
  palette: {
    primary: {
      main: Liquidity.colors.main.primary
    },
    secondary: {
      main: Liquidity.colors.main.secondary,
      dark: Liquidity.colors.main.darkBlue,
      light: Liquidity.colors.main.brightBlue
    },
    error: {
      main: Liquidity.colors.feedback.error
    },
    warning: {
      main: Liquidity.colors.feedback.warning
    },
    success: {
      main: Liquidity.colors.feedback.success
    },
    info: {
      main: Liquidity.colors.greys.base,
      light: Liquidity.colors.greys.light
    }
  },
  shape: {
    borderRadius: Liquidity.measurements.shape.borderRadius
  },
  spacing: Liquidity.measurements.spacing,
  typography: {
    allVariants: {
      fontFamily: undefined
    }
  },
  overrides: overrides
});
var SEARCH_BAR_TESTID_ROOT = 'components:search-bar';
var SEARCH_BAR_TESTIDS = {
  form: SEARCH_BAR_TESTID_ROOT + ":form",
  input: SEARCH_BAR_TESTID_ROOT + ":input",
  submit: SEARCH_BAR_TESTID_ROOT + ":submit",
  close: SEARCH_BAR_TESTID_ROOT + ":close"
};
var useStyles$6 = /*#__PURE__*/
makeStyles$1(function (theme) {
  return createStyles({
    container: {
      display: 'flex'
    },
    wrapper: {
      width: '90%',
      '&$adornedStart': {
        paddingLeft: theme.spacing(1)
      }
    },
    input: {
      height: 'auto',
      lineHeight: '1.25rem'
    },
    inputMarginDense: {
      padding: theme.spacing(1, 1, 1, 0)
    },
    icon: {
      cursor: 'pointer',
      height: 24,
      padding: theme.spacing(0.25),
      width: 'auto'
    },
    adornedStart: {
      paddingLeft: theme.spacing(1),
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    positionStart: {
      height: 'auto',
      maxHeight: 'none',
      padding: theme.spacing(1, 0)
    },
    button: {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
      marginLeft: '-1px'
    },
    iconFocus: {
      color: Liquidity.colors.main.brightBlue
    },
    focus: {
      backgroundColor: Liquidity.colors.main.brightBlue,
      color: Liquidity.colors.text.inverse,
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: Liquidity.colors.main.brightBlue
      }
    }
  });
});
var SearchBar = function SearchBar(_a) {
  var value = _a.value,
    onChange = _a.onChange,
    onSubmit = _a.onSubmit,
    onClear = _a.onClear,
    showCloseIcon = _a.showCloseIcon,
    _b = _a.submitButtonText,
    submitButtonText = _b === void 0 ? 'SEARCH' : _b,
    _c = _a.placeholder,
    placeholder = _c === void 0 ? 'Search...' : _c;
  var inputRef = useRef();
  var classes = useStyles$6();
  var _d = useState(false),
    focus = _d[0],
    setFocus = _d[1];
  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event.target.value);
    }
  };
  var handleCloseIconClick = function handleCloseIconClick() {
    if (onClear) {
      onClear();
    }
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(inputRef.current.value);
    }
  };
  var handleFocus = function handleFocus() {
    setFocus(true);
  };
  var handleBlur = function handleBlur() {
    setFocus(false);
  };
  return React__default.createElement("form", {
    "data-testid": SEARCH_BAR_TESTIDS.form,
    className: classes.container,
    onSubmit: handleSubmit
  }, React__default.createElement(TextField, {
    type: "search",
    variant: "outlined",
    size: "small",
    error: false,
    onChange: handleChange,
    className: classes.wrapper,
    inputRef: inputRef,
    placeholder: placeholder,
    value: value,
    onFocus: handleFocus,
    onBlur: handleBlur,
    InputProps: {
      classes: {
        input: classes.input,
        inputMarginDense: classes.inputMarginDense,
        adornedStart: classes.adornedStart
      },
      inputProps: {
        'data-testid': SEARCH_BAR_TESTIDS.input
      },
      startAdornment: React__default.createElement(InputAdornment, {
        classes: {
          positionStart: classes.positionStart
        },
        position: "start"
      }, React__default.createElement(SearchIcon, {
        className: classes.icon + " " + (focus ? classes.iconFocus : ''),
        color: "secondary"
      })),
      // only show close icon if something has been typed
      endAdornment: (showCloseIcon || !!value) && React__default.createElement(InputAdornment, {
        "data-testid": SEARCH_BAR_TESTIDS.close,
        onClick: handleCloseIconClick,
        position: "end"
      }, React__default.createElement(CloseIcon, {
        className: classes.icon
      }))
    }
  }), React__default.createElement(Button, {
    variant: focus ? 'contained' : 'outlined',
    color: "default",
    onClick: handleSubmit,
    className: classes.button + " " + (focus ? classes.focus : ''),
    "data-testid": SEARCH_BAR_TESTIDS.submit
  }, submitButtonText));
};
var useStyles$7 = /*#__PURE__*/
makeStyles(function (theme) {
  return {
    selectRoot: {
      paddingTop: theme.typography.pxToRem(10),
      paddingBottom: theme.typography.pxToRem(10),
      width: '100%',
      fontSize: theme.typography.pxToRem(14)
    },
    menuItem: {
      fontSize: theme.typography.pxToRem(14)
    }
  };
});
var Select = function Select(_a) {
  var options = _a.options,
    _b = _a.fullWidth,
    fullWidth = _b === void 0 ? false : _b,
    selectProps = __rest(_a, ["options", "fullWidth"]);
  var classes = useStyles$7();
  return React__default.createElement(FormControl, {
    variant: "outlined",
    fullWidth: fullWidth
  }, React__default.createElement(Select$1, __assign({
    classes: {
      root: classes.selectRoot
    }
  }, selectProps), options.map(function (option) {
    return React__default.createElement(MenuItem, {
      value: option.value,
      key: option.value,
      className: classes.menuItem
    }, option.label);
  })));
};
var getMuiAlignment = function getMuiAlignment(value) {
  switch (value) {
    case 'leading':
      return 'left';
    case 'center':
      return 'center';
    case 'trailing':
      return 'right';
    default:
      return 'left';
  }
};
var setColor = function setColor(_a) {
  var isError = _a.isError,
    customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (isError) {
    return Liquidity.colors.text.error;
  }
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$8 = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      fontSize: '1rem',
      fontWeight: function fontWeight(_a) {
        var isEmphasis = _a.isEmphasis;
        return isEmphasis ? 700 : 400;
      },
      lineHeight: 1.5,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor,
      fontFeatureSettings: function fontFeatureSettings(_a) {
        var isTabular = _a.isTabular;
        return isTabular ? "'tnum' 1" : undefined;
      }
    }
  };
});
var TypeBase = function TypeBase(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'p' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    isEmphasis = props.isEmphasis,
    isError = props.isError,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    isTabular = props.isTabular,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "isEmphasis", "isError", "customColor", "spacingBottom", "isTabular", "children", "isInverse"]);
  var classes = useStyles$8(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$1 = function setColor(_a) {
  var isError = _a.isError,
    isFocused = _a.isFocused,
    customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (isError) {
    return Liquidity.colors.text.error;
  }
  if (isFocused) {
    return Liquidity.colors.text.standard;
  }
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standardLight;
};
var useStyles$9 = /*#__PURE__*/
makeStyles$1(function () {
  return {
    root: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: setColor$1
    }
  };
});
var TypeLabel = function TypeLabel(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'label' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    isFocused = props.isFocused,
    isError = props.isError,
    customColor = props.customColor,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "isFocused", "isError", "customColor", "children", "isInverse"]);
  var classes = useStyles$9(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$2 = function setColor(_a) {
  var isError = _a.isError,
    customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (isError) {
    return Liquidity.colors.text.error;
  }
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standardLight;
};
var useStyles$a = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$2
    }
  };
});
var TypeHelper = function TypeHelper(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'p' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    isError = props.isError,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "isError", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$a(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$3 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var setFontWeight = function setFontWeight(_a) {
  var fontWeight = _a.fontWeight;
  return fontWeight || 500;
};
var useStyles$b = /*#__PURE__*/
makeStyles$1(function (theme) {
  var _a;
  return {
    root: (_a = {
      fontSize: '2rem',
      fontWeight: setFontWeight,
      lineHeight: 1.2,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$3
    }, _a[theme.breakpoints.up('sm')] = {
      fontSize: '2.5rem',
      fontWeight: setFontWeight
    }, _a[theme.breakpoints.up('lg')] = {
      fontSize: '3.5rem',
      fontWeight: setFontWeight
    }, _a)
  };
});
var TypePageTitle = function TypePageTitle(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h1' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    fontWeight = props.fontWeight,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse", "fontWeight"]);
  var classes = useStyles$b(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align),
    fontWeight: fontWeight
  }, rest), children);
};
var setColor$4 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$c = /*#__PURE__*/
makeStyles$1(function (theme) {
  var _a;
  return {
    root: (_a = {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.2,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$4
    }, _a[theme.breakpoints.up('sm')] = {
      fontSize: '1.75rem',
      fontWeight: 500
    }, _a[theme.breakpoints.up('lg')] = {
      fontSize: '2.25rem',
      fontWeight: 500
    }, _a)
  };
});
var TypeSectionHeader = function TypeSectionHeader(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h2' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$c(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$5 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$d = /*#__PURE__*/
makeStyles$1(function (theme) {
  var _a;
  return {
    root: (_a = {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.2,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$5
    }, _a[theme.breakpoints.up('sm')] = {
      fontSize: '1.25rem',
      fontWeight: 500
    }, _a[theme.breakpoints.up('lg')] = {
      fontSize: '1.5rem',
      fontWeight: 500
    }, _a)
  };
});
var TypeSubsectionHeader = function TypeSubsectionHeader(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h3' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$d(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$6 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$e = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.5,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      textTransform: 'uppercase',
      color: setColor$6
    }
  };
});
var TypeWidgetHeader = function TypeWidgetHeader(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h4' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$e(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$7 = function setColor(_a) {
  var customColor = _a.customColor;
  if (customColor) {
    return customColor;
  }
  return Liquidity.colors.text.accent;
};
var useStyles$f = /*#__PURE__*/
makeStyles$1(function () {
  return {
    root: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.5,
      color: setColor$7
    }
  };
});
var TypeTableHeader = function TypeTableHeader(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h4' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    children = props.children,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "children"]);
  var classes = useStyles$f(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$8 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$g = /*#__PURE__*/
makeStyles$1(function (theme) {
  var _a;
  return {
    root: (_a = {
      fontSize: '2.5rem',
      fontWeight: 500,
      lineHeight: 1.2,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$8
    }, _a[theme.breakpoints.up('sm')] = {
      fontSize: '3.5rem',
      fontWeight: 300
    }, _a[theme.breakpoints.up('lg')] = {
      fontSize: '5.25rem',
      fontWeight: 300
    }, _a)
  };
});
var TypeHero = function TypeHero(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'h1' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$g(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$9 = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standardLight;
};
var useStyles$h = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.5,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$9
    }
  };
});
var TypeLegalese = function TypeLegalese(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'p' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "children", "isInverse"]);
  var classes = useStyles$h(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var setColor$a = function setColor(_a) {
  var customColor = _a.customColor,
    isInverse = _a.isInverse;
  if (customColor) {
    return customColor;
  }
  if (isInverse) {
    return Liquidity.colors.text.inverse;
  }
  return Liquidity.colors.text.standard;
};
var useStyles$i = /*#__PURE__*/
makeStyles$1(function (theme) {
  return {
    root: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.2,
      paddingBottom: function paddingBottom(_a) {
        var _b = _a.spacingBottom,
          spacingBottom = _b === void 0 ? 0 : _b;
        return spacingBottom > 0 ? theme.spacing(spacingBottom) : 0;
      },
      color: setColor$a,
      fontFeatureSettings: function fontFeatureSettings(_a) {
        var isTabular = _a.isTabular;
        return isTabular ? "'tnum' 1" : undefined;
      }
    }
  };
});
var TypeCallout = function TypeCallout(props) {
  var
    // Give default values to props, pull props we don't want to pass through.
    _a = props.component,
    // Give default values to props, pull props we don't want to pass through.
    component = _a === void 0 ? 'p' : _a,
    _b = props.align,
    align = _b === void 0 ? 'leading' : _b,
    customColor = props.customColor,
    spacingBottom = props.spacingBottom,
    isTabular = props.isTabular,
    children = props.children,
    isInverse = props.isInverse,
    // Remaining properties will pass to Typography and/or be applied to the rendered DOM element.
    rest = __rest(props, ["component", "align", "customColor", "spacingBottom", "isTabular", "children", "isInverse"]);
  var classes = useStyles$i(props);
  return React__default.createElement(Typography, __assign({
    className: classes.root,
    component: component,
    align: getMuiAlignment(align)
  }, rest), children);
};
var TESTID_ROOT = 'snack-card';
var testids = {
  banner: TESTID_ROOT,
  content: /*#__PURE__*/
  [TESTID_ROOT, 'content'].join(':'),
  alert: /*#__PURE__*/
  [TESTID_ROOT, 'alert'].join(':'),
  closeBtn: /*#__PURE__*/
  [TESTID_ROOT, 'close-btn'].join(':')
};
var useStyles$j = /*#__PURE__*/
makeStyles(function (theme) {
  var _a;
  return {
    root: (_a = {}, _a[theme.breakpoints.up('sm')] = {
      maxWidth: theme.spacing(46)
    }, _a),
    wrapper: {
      overflow: 'hidden',
      width: '100%'
    },
    title: function title(_a) {
      var variant = _a.variant;
      return {
        backgroundColor: ALERT_VARIANTS_COLORS[variant],
        borderRadius: 0,
        flexWrap: 'nowrap'
      };
    },
    icon: {
      fontSize: 20,
      marginRight: theme.spacing(1.5)
    },
    closeIcon: {
      flexShrink: 0
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    },
    content: function content(_a) {
      var variant = _a.variant;
      return {
        backgroundColor: fade$1(ALERT_VARIANTS_COLORS[variant], 0.1),
        padding: theme.spacing(2, 2.5)
      };
    }
  };
});
var SnackCard = function SnackCard(_a) {
  var _b;
  var _c = _a.variant,
    variant = _c === void 0 ? 'success' : _c,
    title = _a.title,
    children = _a.children,
    onClose = _a.onClose,
    titleProps = _a.titleProps,
    contentClassName = _a.contentClassName,
    props = __rest(_a, ["variant", "title", "children", "onClose", "titleProps", "contentClassName"]);
  var classes = useStyles$j({
    variant: variant
  });
  return React__default.createElement(Snackbar, __assign({
    "data-testid": testids.banner,
    className: classes.root,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, props), React__default.createElement(Paper, {
    className: classes.wrapper,
    elevation: 6
  }, React__default.createElement(SnackbarContent, __assign({
    "data-testid": testids.content,
    "aria-describedby": testids.alert,
    // remove elevation in favor of wrapper elevation
    elevation: 0,
    message: React__default.createElement(Box$1, {
      className: classes.message
    }, React__default.createElement(CheckCircleIcon, {
      className: classes.icon
    }), React__default.createElement(TypeWidgetHeader, {
      "data-testid": testids.alert,
      id: testids.alert,
      customColor: "inherit"
    }, title)),
    action: [React__default.createElement(IconButton$1, {
      key: "close",
      "aria-label": "close",
      color: "inherit",
      className: classes.closeIcon,
      onClick: onClose,
      "data-testid": testids.closeBtn
    }, React__default.createElement(CloseIcon, null))]
  }, titleProps, {
    // pass className after custom props to merge all classes
    className: clsx(classes.title, (_b = titleProps) === null || _b === void 0 ? void 0 : _b.className)
  })), React__default.createElement(Box$1, {
    className: clsx(classes.content, contentClassName)
  }, children)));
};
var Table = /*#__PURE__*/
withStyles$1({
  root: {
    borderCollapse: 'collapse',
    borderSpacing: 0
  }
})(Table$1);
var TableRow = /*#__PURE__*/
withStyles$1(function (theme) {
  var _a;
  return {
    root: {
      'tbody > &': (_a = {}, _a[theme.breakpoints.up('sm')] = {
        '&$selected': {
          backgroundColor: 'inherit'
        },
        '&:nth-of-type(even)': {
          backgroundColor: fade$2(Liquidity.colors.greys.light, 0.25)
        },
        // leave the hover state after the nth-of-type for specificity
        '&:hover, &$selected:hover': {
          backgroundColor: fade$2(Liquidity.colors.main.brightBlue, 0.1)
        }
      }, _a)
    },
    selected: {}
  };
})(TableRow$1);
var TableCell = /*#__PURE__*/
withStyles$1(function (theme) {
  return {
    root: {
      padding: theme.spacing(1),
      '&:first-child': {
        paddingLeft: theme.spacing(2)
      },
      '&:last-child': {
        paddingRight: theme.spacing(2)
      },
      'thead tr:last-child &': {
        borderBottom: "1px solid " + Liquidity.colors.main.secondary
      }
    }
  };
})(TableCell$1);
var StyledArrowDownIcon = /*#__PURE__*/
withStyles$1(function (theme) {
  return {
    root: {
      fontSize: theme.typography.pxToRem(14)
    }
  };
})(LongArrowDownIcon);
var TableSortLabel = /*#__PURE__*/
withDefaults(TableSortLabel$1, {
  IconComponent: function IconComponent(_a) {
    var className = _a.className;
    return React__default.createElement(StyledArrowDownIcon, {
      className: className
    });
  }
}); // export non-modified components & component props

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme;
  return React__default.createElement(MuiThemeProvider, __assign({
    theme: theme
  }, props), props.children);
};
var useStyles$k = /*#__PURE__*/
makeStyles$2(function () {
  return {
    root: {
      filter: function filter(_a) {
        var rootBlur = _a.rootBlur;
        return rootBlur ? 'blur(1.5px)' : 'none';
      },
      minHeight: '100%'
    }
  };
});
var C2foComponentsRootProvider = function C2foComponentsRootProvider(props) {
  var _a = useState(false),
    isModalOpen = _a[0],
    setModalOpen = _a[1];
  var classes = useStyles$k({
    rootBlur: isModalOpen
  });
  return React__default.createElement(ThemeProvider, {
    theme: C2FOTheme
  }, React__default.createElement(CssBaseline, null), React__default.createElement(ModalContext.Provider, {
    value: {
      isModalOpen: isModalOpen,
      setModalOpen: setModalOpen
    }
  }, React__default.createElement("div", {
    className: classes.root
  }, props.children)));
};
export { AddIcon, Alert, AlertBanner, AngleDownIcon, AngleLeftIcon, AngleRightIcon, AngleUpIcon, ArrowDownIcon, ArrowDropUpIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, Avatar, BanIcon, BarsIcon, BoltIcon, Box, Button, ButtonDropdown, ButtonDropdownItem, C2FOTheme, C2foComponentsRootProvider, CalendarIcon, CheckCircleIcon, CheckIcon, Checkbox, Chip, ClockIcon, CloseIcon, CloudUploadIcon, CogIcon, CopyIcon, DownloadIcon, ExclamationCircleIcon, ExclamationSquareIcon, ExclamationTriangleIcon, EyeIcon, FilterIcon, HistoryIcon, IconButton, InboxIcon, InfoIcon, Link, Liquidity, ListAltIcon, LockAltIcon, Logo, LongArrowDownIcon, LongArrowUpIcon, Modal, ModalContext, MoreVertIcon, Pagination, PencilIcon, QuestionCircleIcon, Radio, RepeatingIcon, SEARCH_BAR_TESTIDS, SearchBar, SearchIcon, Select, SnackCard, SortAmountDownIcon, SortAmountUpIcon, SyncIcon, Table, TableCell, TableRow, TableSortLabel, TagIcon, ThemeProvider, TimesCircleIcon, TrashIcon, TypeBase, TypeCallout, TypeHelper, TypeHero, TypeLabel, TypeLegalese, TypePageTitle, TypeSectionHeader, TypeSubsectionHeader, TypeTableHeader, TypeWidgetHeader, UploadIcon, testids };